import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@fortawesome/fontawesome-free/css/all.css' 
Vue.use(Vuetify,{
    iconfont: 'fa' // 'md' || 'mdi' || 'fa' || 'fa4'
  });

export default new Vuetify({
});
